import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { Subscription } from 'rxjs';
import {RcInviewService} from '../../../rc-utils/rc-inview/rc-inview.service';


/**
 * Rc inview directive - emit a callback function with true / false each time the element enter or out the screen
 * Support a margin value - in order to prevent the content to be seen loaded
 *
 * @example
 * <div lib-rc-inview [rcInviewMargin]="200" (rcInviewCallback)="inview($event)">some content</div>
 */

@Directive({
    selector: '[lib-rc-inview]'
})
export class RcInviewDirective implements OnInit, OnDestroy {

    /**
     * element margin to trigger the callback
     */
    @Input() rcInviewMargin: number = 0;

    /**
     * a callback function trigger once the element enter or our the screen
     */
    @Output() rcInviewCallback: EventEmitter<any> = new EventEmitter();

    private inside: boolean = null;
    private scrollSubscriber: Subscription;


    constructor(private elem: ElementRef, private rcInviewService: RcInviewService) {
    }

    /**
     * subscribe to scrolling event and calculate init state of element
     */
    ngOnInit(): void {
        this.scrollSubscriber = this.rcInviewService.scrollEmitter.subscribe(() => {
            this.isInViewport();
        });
        this.isInViewport();
    }

    /**
     * calculate if the element got out or into the screen and emit a callback accordingly
     */
    isInViewport(): void {
        const rect = this.elem.nativeElement.getBoundingClientRect();
        const html = document.documentElement;
        const isVisible = (
            (rect.top + rect.height) >= 0 &&
            (rect.bottom - rect.height - this.rcInviewMargin) <= (window.innerHeight || html.clientHeight));

        if (isVisible !== this.inside) {
            this.inside = isVisible;
            this.rcInviewCallback.emit(this.inside);
        }
    }

    /**
     * unsubscribe from event
     */
    ngOnDestroy(): void {
        this.scrollSubscriber.unsubscribe();
    }
}
